import { defineComponent as _defineComponent } from 'vue'
import { isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';
import Lottie from 'lottie-web';
import kikker from '@/assets/kikker.json';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const Anim = ref(null) as HTMLDivElement | null;

onMounted(() => {
  const div = Anim.value;
  if (!div) {
    throw Error('Anim not found');
  }
  const params = {
    container: Anim.value,
    renderer: 'svg',
    loop: false,
    autoplay: true,
    animationData: kikker,
  };

  const lottiePlayer : void = Lottie;
  lottiePlayer.loadAnimation(params);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: (_value, _refs) => {
      _refs['Anim'] = _value
      _isRef(Anim) && (Anim.value = _value)
    }
  }, null, 512))
}
}

})